import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n/I18nContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SiteLayout from "@/components/site/SiteLayout";

import Home from "@/pages/marketing/Home";
import About from "@/pages/marketing/About";
import Nfc from "@/pages/marketing/Nfc";
import DigitalCards from "@/pages/marketing/DigitalCards";
import HowItWorks from "@/pages/marketing/HowItWorks";
import Pricing from "@/pages/marketing/Pricing";
import Faq from "@/pages/marketing/Faq";
import Contact from "@/pages/marketing/Contact";
import Legal from "@/pages/marketing/Legal";

import Login from "@/pages/Login";
import Fiche from "@/pages/Fiche";
import NotFound from "@/pages/NotFound";
import Dashboard from "@/pages/dashboard/Dashboard";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/nfc" element={<Nfc />} />
              <Route path="/fiches-digitales" element={<DigitalCards />} />
              <Route path="/fonctionnement" element={<HowItWorks />} />
              <Route path="/tarifs" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<Legal type="mentions" />} />
              <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
            </Route>

            <Route path="/connexion" element={<Login />} />
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/:slug" element={<Fiche />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
